import { render, staticRenderFns } from "./prdProducaoDetalhe.vue?vue&type=template&id=b9dda2c8&scoped=true&"
import script from "./prdProducaoDetalhe.vue?vue&type=script&lang=js&"
export * from "./prdProducaoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./prdProducaoDetalhe.vue?vue&type=style&index=0&id=b9dda2c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dda2c8",
  null
  
)

export default component.exports